import { render } from "./Pagination.vue?vue&type=template&id=6f6a86d3"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/staderecord/assets/js/components/utils/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f6a86d3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f6a86d3', __exports__)) {
    api.reload('6f6a86d3', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=6f6a86d3", () => {
    api.rerender('6f6a86d3', render)
  })

}


export default __exports__